


export default {
    // 公共
    hello:"Hello~",
    welcome: "歡迎來到 Plus18 Games 客服中心",
    connecting: "您的專屬客服正在接入中...",
    connected: "您的專屬客服已接入完成",
    waitting: "請稍等片刻",
    click_to_chat: "請點擊右下按鈕進入對話",
    email:"客服郵箱",
    kefu:"客服",
    kefu_center:"客服中心",

}